const testimonials = [
  {
    name: "Mark T.",
    location: "Joplin, MO — Manufacturing Industry",
    rating: 5,
    text: "I had to be in Monterrey, Mexico in 10 days for a supplier audit and realized my passport expired eight months ago. Joplin is 3+ hours from St. Louis and there was no way I could get an appointment in time. Found Fast Passport Center online, shipped my documents overnight from the Joplin FedEx, and had my renewed passport back in 7 business days. Absolutely saved the trip.",
    service: "Passport Renewal",
  },
  {
    name: "Sarah K.",
    location: "Webb City, MO — MSSU Faculty",
    rating: 5,
    text: "I needed to travel to a conference in Amsterdam and my passport had expired. With just three weeks until departure, I was convinced I was out of options without driving to St. Louis. Fast Passport Center was the answer — professional, organized, and my passport arrived with four days to spare before my flight out of XNA. I have already told every colleague at MSSU about them.",
    service: "Expedited Renewal",
  },
  {
    name: "Robert & Linda H.",
    location: "Carthage, MO — Retired",
    rating: 5,
    text: "We booked a Mediterranean cruise through Galveston and discovered Linda's passport had expired six months earlier. The cruise was six weeks out. We called Fast Passport Center, followed their instructions, shipped overnight from Carthage, and received Linda's renewed passport in 8 business days. We made the cruise and had an amazing time. Do not hesitate to call them.",
    service: "Emergency Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function JoplinTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Joplin &amp; Tri-State Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real experiences from Joplin, Webb City, and Carthage travelers who trusted Fast Passport Center with their expedited passport needs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col">
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}